import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import styled from "styled-components";
import moment from "moment";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import DataTable from "react-data-table-component";
import { getUserLog } from "services/ConfigServices";
import { logtypeData, logeventData } from "variables/lists/users";
import { userlogpagetext } from "variables/users";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import ReactLoading from "react-loading";

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;
const LoadingDiv = styled.div`
height: 20vh;
width: 20vw;
display: flex;
justify-content: center;
padding-top: 0vh;
flex-direction: column;
align-items: center;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "63ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "63ch",
  },
}));

function ViewLogDialog(props) {
  const { user } = props;
  const appContext = useContext(AdvancedSearchContext);
  const { groupInfoListById } = appContext;

  const [data, setData] = useState([]);
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios
      .get(getUserLog(user.id), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        setData(res.data);
        setLoading(false);
      })
      .catch(() => { setLoading(false); });

  }, []);

  const columns = [
    {
      name: userlogpagetext.date,
      selector: (row) => row.timestamp,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) =>
        row.timestamp && moment(row.timestamp).isValid()
          ? moment(row.timestamp).format("DD/MM/YYYY HH:mm")
          : "",
    },
    {
      name: userlogpagetext.type,
      selector: (row) => row.type,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => logtypeData.find((x) => x.id == row.type)?.name || row.type
    },
    {
      name: userlogpagetext.event,
      selector: (row) => row.event,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) =>
        row.type === 'page visit' ? 'Page ' + row.event :
          row.type === 'call' ? 'Appel ' + row.event :
            row.type === 'connection' ? logeventData.find((x) => x.id == row.event)?.name || row.event :
              row.type === 'group update' ?
                (row.event.subtype === 'move' ? 'Déplacement du groupe \'' + groupInfoListById["" + row.event.groupid] + '\' sur le compte \'' + groupInfoListById["" + row.event.accountid] :
                  row.event.subtype) :
                ''
    }
  ]


  return (
    <>
      <form className={classes.root}>
        {user &&
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <Container>
                <DataTable
                  paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                  dense
                  noDataComponent={<NoData>{userlogpagetext.nodata}</NoData>}
                  noHeader={true}
                  columns={columns}
                  persistTableHead
                  pagination
                  data={data}
                  progressPending={loading}
                  progressComponent={<div><LoadingDiv>{userlogpagetext.loading}<ReactLoading
                    type={"bars"}
                    color={"#91c241"}
                    height={"10%"}
                    width={"10%"}
                  /></LoadingDiv></div>}
                  paginationComponentOptions={{
                    noRowsPerPage: false,
                    rowsPerPageText: "Lignes par page",
                    rangeSeparatorText: "sur",
                    selectAllRowsItem: false,
                    selectAllRowsItemText: "Selectionner toutes les lignes",
                  }}
                />
              </Container>
            </GridItem>
          </GridContainer>}
      </form>
    </>
  );
}

export default ViewLogDialog;
